import { DataFieldService } from '@fi-app/data-field/data-field.service';
import { ObjectTypes } from '@fi-shared/types/object-type';

export const FiBusinessUnitStateResolveDataFieldGroup = [
    DataFieldService,
    FiBusinessUnitStateResolveFiBusinessUnitStateResolveDataFieldGroup_resolveFunc,
];

export function FiBusinessUnitStateResolveFiBusinessUnitStateResolveDataFieldGroup_resolveFunc(
    dataFieldService: DataFieldService,
) {
    return dataFieldService.getDataFieldGroup(ObjectTypes.BusinessUnit);
}
